import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const AlertWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-gap: ${pxToRem('29px')};

  > div {
    background: white;
    padding: ${pxToRem('33px')} ${pxToRem('40px')};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    align-content: center;
    border: ${pxToRem('2px')} solid ${props => props.theme.colors.lightGray3};
    border-radius: ${pxToRem('10px')};
  }
`;
